import {
  RegionalOverviewFilterType,
  buildFilter,
  type Filter,
  type FilterValue
} from '@features/regional-overview/regional-overview.models';
import type { Feature, Geometry } from 'geojson';

interface BuildTextSearchFilterOptions<P> {
  extractSearchable: (feature: Feature<Geometry, P>) => string[];
}

const readSearchQuery = (value: FilterValue): string | undefined => {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  return trimmed.length === 0 ? undefined : trimmed.toLowerCase();
};

export const buildTextSearchFilter = <P>({ extractSearchable }: BuildTextSearchFilterOptions<P>): Filter =>
  buildFilter<P>({
    type: RegionalOverviewFilterType.TEXT_SEARCH,
    defaultValue: undefined,
    translatable: false,
    freeform: true,
    getValues: () => [],
    matches: (feature, value) => {
      const query = readSearchQuery(value);
      if (!query) return true;
      const haystack = extractSearchable(feature).join(':').toLowerCase();
      return haystack.includes(query);
    }
  });
